/**
 * Storage barrel — picks the right IStorage impl for the current platform.
 *
 * Today: web only → re-exports `webStorage` as `storage`.
 * Phase 4 (roadmap Phase 2): adds a Capacitor impl backed by
 * `@capacitor/preferences` for iOS Keychain / Android encrypted
 * SharedPreferences. Selection is build-time via Vite env var:
 *
 *     // future:
 *     import { capacitorStorage } from './capacitor';
 *     export const storage: IStorage = import.meta.env.VITE_PLATFORM === 'native'
 *       ? capacitorStorage
 *       : webStorage;
 *
 * Until then, the web impl is the only impl. Importers throughout the app
 * use `storage` from this barrel, not `webStorage` directly, so the swap
 * in Phase 4 is a one-file change.
 */

import type { IStorage } from '../interfaces/IStorage';
import { webStorage } from './web';

export const storage: IStorage = webStorage;
export type { IStorage } from '../interfaces/IStorage';
